import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";

const ViewTruck = (props) => {
  const [showPopover, setShowPopover] = useState(false);
  const [position, setPosition] = useState({ left: 0, top: 0 });

  const handleRouteClick = (e) => {
    props.context.componentParent.onClickentertruckdetails(props);
  };

  const indent = props.data.indent;
  const vendorQuotes =
    indent && Array.isArray(indent.vendorquotes) ? indent.vendorquotes : [];
  const currentVendorEmail = localStorage.getItem("email");

  const hasVendorQuote = vendorQuotes.some(
    (x) => x.vendor_email_id === currentVendorEmail
  );
  const enabled = vendorQuotes.find(
    (x) =>
      x.vendor_email_id === currentVendorEmail &&
      x.indent_accepted_by_vendor == 1
  );

  const isEnabled = indent && hasVendorQuote && enabled;

  // hover logic
  const handleMouseEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setPosition({
      left: rect.left + rect.width / 2,
      top: rect.top - 35 + window.scrollY,
    });
    setShowPopover(true);
  };

  const handleMouseLeave = () => setShowPopover(false);

  return (
    <div style={{ display: "flex", position: "relative" }}>
      <button
        onClick={(e) => {
          if (isEnabled) handleRouteClick(e);
        }}
        className="custom-btn label label-success"
        style={{ cursor: isEnabled ? "pointer" : "not-allowed" }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <i className="icofont icofont-fast-delivery f18"></i>
      </button>

      {showPopover && (
        <PopoverContent
          content="Truck Details"
          position={position}
          onClose={() => setShowPopover(false)}
        />
      )}
    </div>
  );
};
const PopoverContent = ({ content, position, onClose }) => {
  const popoverRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return createPortal(
    <div
      ref={popoverRef}
      style={{
        position: "absolute",
        left: `${position.left}px`,
        top: `${position.top}px`,
        zIndex: 1000,
        backgroundColor: "#333",
        color: "#fff",
        borderRadius: "4px",
        padding: "6px 10px",
        fontSize: "12px",
        whiteSpace: "nowrap",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        transform: "translateX(-50%)",
      }}
    >
      {content}
      <div
        style={{
          position: "absolute",
          bottom: "-5px",
          left: "50%",
          transform: "translateX(-50%)",
          width: 0,
          height: 0,
          borderLeft: "5px solid transparent",
          borderRight: "5px solid transparent",
          borderTop: "5px solid #333",
        }}
      />
    </div>,
    document.body
  );
};

export default ViewTruck;
